import React from 'react';
import { Helmet } from "react-helmet";
import { useTranslation } from "react-i18next";

const CommonHelmet = ({ title, desc, h1Content }) => {
    const {i18n, t } = useTranslation();
    return (
        <>
          {h1Content && <h1 className="seo-h1">{h1Content}</h1>}
            <Helmet>
                <title>{title}</title>
                <meta name="description"
                    content={desc} />
                <link rel='canonical' href={window.location.href} />
                <link rel="alternate" href={window.location.href} hreflang={i18n.resolvedLanguage} />
            </Helmet>
        </>
    )
};
export default CommonHelmet;
